import { useEffect, useRef, useState } from "react";
import PositionClient, { PositionErrors } from '../apiClients/PositionClient';
import { Position } from "../models/dtos";
import { useErrorDisplay } from "../components/ErrorDisplay"
import BusySpinner from "../components/BusySpinner";
import { Paper } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { NameIdListItem } from "../models/custom-models";
import { IsNotEmpty } from "../Helpers";

export interface PositionAutocompleteProps {
    onUserSelect?: (positionId: string) => (void | Promise<void>);
    positionId: string;
    label?: string;
}

const PositionAutocompleteControl = ({ positionId, onUserSelect, label = 'Positions' }: PositionAutocompleteProps) => {

    const [ErrorDisplay, setError] = useErrorDisplay();
    const [busy, setBusy] = useState<boolean>(false);

    const [positions, setPositions] = useState<NameIdListItem[]>([]);
    const [selectedPosition, setSelectedPosition] = useState<NameIdListItem>(null);

    const initialized = useRef<boolean>(false);

    const loadData = async () => {
        try {
            setBusy(true);
            let p = await new PositionClient().GetAll();

            var options = mapToOptions(p);
            setPositions(sortByName(options));

        } catch (error) {
            setError(error, PositionErrors.GetAll);
        }
        finally {
            setBusy(false);
        }
    };

    const mapToOptions = (positions: Position[]): NameIdListItem[] => {
        var options = positions.map((p) => (
            { Id: p.Id, Name: p.Title, IsSelected: false } as NameIdListItem
        ));

        return options;
    }

    useEffect(() => {
        if (initialized.current)
            return;

        initialized.current = true;
        loadData();
    });

    useEffect(() => {

        if (IsNotEmpty(positionId)) {
            let selectPosition = positions.find(x => x.Id === positionId) ?? null;
            setSelectedPosition(selectPosition);
        }

    }, [positionId, positions]);

    const sortByName = (list) => list.sort((a, b) => a.Name.localeCompare(b.Name));

    const handleOnChange = (e, v: NameIdListItem | null) => {
        if (IsNotEmpty(v)){
            onUserSelect(v.Id);
        }
        else{
            setSelectedPosition(v);
        }
    }


    return (
        <>
            <ErrorDisplay />
            <BusySpinner component={Paper} busy={busy} >
                <Autocomplete
                    autoComplete={true}
                    autoSelect={true}
                    id="position-autocomplete"
                    options={positions}
                    getOptionLabel={(option: NameIdListItem) => option?.Name}
                    value={selectedPosition}
                    isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
                    onChange={handleOnChange}
                    sx={{ width: '100%' }}
                    renderInput={(params) => <TextField {...params} required label={label} variant="outlined" />}
                />
            </BusySpinner>
        </>
    )

};


export default PositionAutocompleteControl;
